import React from 'react';
import { Card } from 'primereact/card';

import type { Certificate } from 'features/dashboard/types/dashboard';
import '../../../styles/pages.css';

const statusClass: Record<Certificate['status'], string> = {
  Active:   'certCard__statusBadge--active',
  Pending:  'certCard__statusBadge--pending',
  Expired:  'certCard__statusBadge--expired',
  Archived: 'certCard__statusBadge--archived',
};

export type CertificateCardProps = {
  certificate: Certificate;
  onEdit?: () => void;
  onSend?: () => void;
  onPreview?: () => void;
  onRestore?: () => void;
  isRestoring?: boolean;
};

export default function CertificateCard({ certificate, onEdit, onSend, onPreview, onRestore, isRestoring }: CertificateCardProps) {
  const isArchived = certificate.status === 'Archived';

  return (
    <Card className="certCard">
      <div className="certCard__body">

        {/* Header: icon + status badge */}
        <div className="certCard__header">
          <div className="certCard__iconWrap">
            <i className="pi pi-file" />
          </div>
          <span className={`certCard__statusBadge ${statusClass[certificate.status]}`}>
            {certificate.status}
          </span>
        </div>

        {/* Content: title + line of business */}
        <div className="certCard__content">
          <div className="certCard__title" title={certificate.title}>{certificate.title}</div>
          {/* <div className="certCard__sub">{certificate.lineOfBusiness}</div> */}
        </div>

        {/* Footer: actions */}
        <div className="certCard__footer">
          {isArchived ? (
            <button
              className="certCard__actionBtn certCard__actionBtn--restore"
              onClick={(e) => { e.stopPropagation(); onRestore?.(); }}
              disabled={isRestoring}
              type="button"
            >
              <i className={`pi ${isRestoring ? 'pi-spin pi-spinner' : 'pi-replay'}`} />
              {isRestoring ? 'Restoring…' : 'Restore'}
            </button>
          ) : (
            <>
              {onPreview && (
                <button
                  className="certCard__actionBtn certCard__actionBtn--preview"
                  onClick={(e) => { e.stopPropagation(); onPreview(); }}
                  type="button"
                  title="Preview"
                >
                  <i className="pi pi-eye" />
                </button>
              )}
              <div className="certCard__actions">
                {onEdit && (
                  <button
                    className="certCard__actionBtn certCard__actionBtn--edit"
                    onClick={(e) => { e.stopPropagation(); onEdit(); }}
                    type="button"
                  >
                    <i className="pi pi-pencil" />
                    Edit
                  </button>
                )}
                {onSend && (
                  <button
                    className="certCard__actionBtn certCard__actionBtn--send"
                    onClick={(e) => { e.stopPropagation(); onSend(); }}
                    type="button"
                  >
                    <i className="pi pi-send" />
                    Send
                  </button>
                )}
              </div>
            </>
          )}
        </div>

      </div>
    </Card>
  );
}
